import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { locomotorasService } from '../../services/api';
import api from '../../services/api';

function getServicios() {
  try { return JSON.parse(localStorage.getItem('servicios_activos') || '[]'); }
  catch { return []; }
}
function saveServicios(servicios) {
  localStorage.setItem('servicios_activos', JSON.stringify(servicios));
}

const DIAS_SEMANA = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
const MESES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

const TIPO_COLORS = {
  servicio: { bg: '#eaf3de', color: '#3b6d11', label: '🚂' },
  guardia:  { bg: '#e8f0fe', color: '#1a56db', label: '🛡' },
  trabajos: { bg: '#faeeda', color: '#854f0b', label: '🔧' },
};

export default function Inicio() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('calendario');
  const [servicios, setServicios] = useState([]);
  const [locomotoras, setLocomotoras] = useState([]);
  const [modalNuevo, setModalNuevo] = useState(false);
  const [locoId, setLocoId] = useState('');
  const [servicioPredefinidoSeleccionado, setServicioPredefinidoSeleccionado] = useState(null);
  const [misServicios, setMisServicios] = useState([]);
  const [mesActual, setMesActual] = useState(new Date());
  const [diaSeleccionado, setDiaSeleccionado] = useState(new Date().getDate());

  useEffect(() => {
    setServicios(getServicios());
    locomotorasService.getAll().then(r => setLocomotoras(r.data.filter(l => l.activa)));
    api.get('/planificacion/mis-servicios').then(r => setMisServicios(r.data)).catch(() => {});
  }, []);

  const crearServicioDesde = async (servicioPredefinido) => {
    setServicioPredefinidoSeleccionado(servicioPredefinido);
    setLocoId('');
    setModalNuevo(true);
    // Preseleccionar locomotora del resumen SIGES
    try {
      const fecha = new Date().toISOString().split('T')[0];
      const r = await api.get('/siges/resumen-hoy?fecha=' + fecha);
      const srv = r.data?.find(s => s.servicio_codigo === servicioPredefinido.servicio_codigo);
      if (srv?.locomotora_real) {
        const loco = locomotoras.find(l => l.numero === srv.locomotora_real);
        if (loco) setLocoId(String(loco.id));
      }
    } catch {}
  };

  const crearServicio = () => {
    if (!locoId) { alert('Selecciona una locomotora'); return; }
    const loco = locomotoras.find(l => l.id === parseInt(locoId));
    const nuevo = {
      id: Date.now(),
      loco_id: loco.id,
      loco_numero: loco.numero,
      fecha: new Date().toISOString().split('T')[0],
      servicio_codigo: servicioPredefinidoSeleccionado?.servicio_codigo || servicioPredefinidoSeleccionado?.turno_nombre || null,
      hora_inicio: servicioPredefinidoSeleccionado?.hora_inicio || null,
      hora_fin: servicioPredefinidoSeleccionado?.hora_fin || null,
      checklist_previo: null,
      parte_trabajo: null,
      checklist_final: null,
      enviado: false,
    };
    const nuevos = [...servicios, nuevo];
    setServicios(nuevos);
    saveServicios(nuevos);
    setModalNuevo(false);
    setLocoId('');
    setServicioPredefinidoSeleccionado(null);
    navigate(`/maquinista/servicio/${nuevo.id}`);
  };

  const borrarServicio = (id) => {
    if (!window.confirm('¿Eliminar este servicio?')) return;
    const nuevos = servicios.filter(s => s.id !== id);
    setServicios(nuevos);
    saveServicios(nuevos);
  };

  // Calendario
  const año = mesActual.getFullYear();
  const mes = mesActual.getMonth();
  const primerDia = new Date(año, mes, 1);
  const diasEnMes = new Date(año, mes + 1, 0).getDate();
  const inicioDia = primerDia.getDay() === 0 ? 6 : primerDia.getDay() - 1;

  const diasConServicio = new Set(
    misServicios
      .filter(s => {
        const f = new Date(s.fecha);
        return f.getFullYear() === año && f.getMonth() === mes;
      })
      .map(s => new Date(s.fecha).getDate())
  );

  const serviciosActivos = servicios.filter(s => !s.enviado);

  return (
    <div style={{ maxWidth: 480, margin: '0 auto', padding: '20px 16px', fontFamily: 'system-ui, sans-serif', minHeight: '100vh', background: '#f5f4f0' }}>
      {/* Cabecera */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 600, margin: 0 }}>Hola, {usuario?.nombre}</h1>
          <p style={{ fontSize: 12, color: '#888', margin: '3px 0 0' }}>Loconode</p>
        </div>
        <button onClick={() => { logout(); navigate('/login'); }} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13, color: '#555' }}>
          Salir
        </button>
      </div>

      {/* Nuevo servicio */}
      <button onClick={() => setModalNuevo(true)} style={{
        width: '100%', padding: '14px', borderRadius: 12, border: '2px dashed #ddd',
        background: '#fff', cursor: 'pointer', fontSize: 15, fontWeight: 500, color: '#333',
        marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
      }}>
        <span style={{ fontSize: 20 }}>+</span> Nuevo servicio
      </button>

      {/* Servicio Ferrovial */}
      {(() => {
        let enCurso = 0;
        try { enCurso = JSON.parse(localStorage.getItem('servicios_ferrovial') || '[]').filter(x => !x.fin_enviado).length; } catch {}
        return (
          <button onClick={() => navigate('/maquinista/ferrovial')} style={{
            width: '100%', padding: '14px', borderRadius: 12, border: '2px solid #1a1a1a',
            background: '#fff', cursor: 'pointer', fontSize: 15, fontWeight: 500, color: '#1a1a1a',
            marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8
          }}>
            🚄 Servicio Ferrovial
            {enCurso > 0 && <span style={{ background: '#a32d2d', color: '#fff', borderRadius: 10, padding: '1px 8px', fontSize: 12 }}>{enCurso} en curso</span>}
          </button>
        );
      })()}

      {/* Servicios asignados hoy */}
      {(() => {
        const hoy = new Date();
        const serviciosHoy = misServicios.filter(s => {
          const f = new Date(s.fecha + 'T12:00:00');
          return f.getDate() === hoy.getDate() && f.getMonth() === hoy.getMonth() && f.getFullYear() === hoy.getFullYear();
        });
        if (serviciosHoy.length === 0) return null;
        return (
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>Servicios de hoy</div>
            {serviciosHoy.map(s => (
              <div key={s.id} style={{ background: '#fff', borderRadius: 12, padding: '12px 14px', marginBottom: 8, border: '1px solid #e5e5e5', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <div style={{ fontWeight: 600, fontSize: 14 }}>{s.servicio_codigo || s.turno_nombre}</div>
                  <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{s.hora_inicio?.substring(0,5)} — {s.hora_fin?.substring(0,5)}</div>
                </div>
                <button onClick={() => crearServicioDesde(s)} style={{
                  padding: '8px 14px', borderRadius: 8, border: 'none',
                  background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 500
                }}>Iniciar →</button>
              </div>
            ))}
          </div>
        );
      })()}

      {/* Servicios activos (a medias) */}
      {serviciosActivos.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: '#888', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>SERVICIOS ACTIVOS</div>
          {serviciosActivos.map(s => {
            const pasos = [
              { key: 'checklist_previo', label: 'Checklist inicio' },
              { key: 'parte_trabajo', label: 'Parte de trabajo' },
              { key: 'checklist_final', label: 'Checklist final' },
            ];
            const completados = pasos.filter(p => s[p.key]).length;
            return (
              <div key={s.id} style={{ background: '#fff', borderRadius: 12, padding: 16, marginBottom: 8, border: '1px solid #e5e5e5' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div onClick={() => navigate(`/maquinista/servicio/${s.id}`)} style={{ cursor: 'pointer', flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 15 }}>🚂 {s.loco_numero}</div>
                    <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>{s.fecha} · {completados}/3 completados</div>
                    <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                      {pasos.map(p => (
                        <div key={p.key} style={{
                          width: 8, height: 8, borderRadius: '50%',
                          background: s[p.key] ? '#16a34a' : '#e5e5e5'
                        }} />
                      ))}
                    </div>
                  </div>
                  <button onClick={() => borrarServicio(s.id)} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: '#ccc', padding: 4 }}>✕</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['calendario', '📅 Calendario'], ['servicios', '📋 Servicios']].map(([val, label]) => (
          <button key={val} onClick={() => setTab(val)} style={{
            flex: 1, padding: '10px', borderRadius: 10, border: 'none', cursor: 'pointer',
            fontSize: 13, fontWeight: 500,
            background: tab === val ? '#1a1a1a' : '#fff',
            color: tab === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>

      {/* Tab Calendario */}
      {tab === 'calendario' && (
        <div style={{ background: '#fff', borderRadius: 14, padding: 16 }}>
          {/* Navegador mes */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <button onClick={() => setMesActual(new Date(año, mes - 1, 1))} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: '#555' }}>‹</button>
            <span style={{ fontWeight: 600, fontSize: 15 }}>{MESES[mes]} {año}</span>
            <button onClick={() => setMesActual(new Date(año, mes + 1, 1))} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 18, color: '#555' }}>›</button>
          </div>

          {/* Días semana */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', marginBottom: 8 }}>
            {DIAS_SEMANA.map(d => (
              <div key={d} style={{ textAlign: 'center', fontSize: 11, fontWeight: 600, color: '#aaa', padding: '4px 0' }}>{d}</div>
            ))}
          </div>

          {/* Días del mes */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 4 }}>
            {Array.from({ length: inicioDia }).map((_, i) => <div key={`e${i}`} />)}
            {Array.from({ length: diasEnMes }).map((_, i) => {
              const dia = i + 1;
              const hoy = new Date();
              const esHoy = dia === hoy.getDate() && mes === hoy.getMonth() && año === hoy.getFullYear();
              const tieneServicio = diasConServicio.has(dia);
              return (
                <div key={dia} style={{
                  textAlign: 'center', padding: '6px 2px', borderRadius: 8, fontSize: 13,
                  fontWeight: tieneServicio || esHoy ? 600 : 400,
                  background: esHoy ? '#1a1a1a' : tieneServicio ? '#eaf3de' : 'transparent',
                  color: esHoy ? '#fff' : tieneServicio ? '#3b6d11' : '#333',
                  cursor: tieneServicio ? 'pointer' : 'default'
                }} onClick={() => tieneServicio && setDiaSeleccionado(diaSeleccionado === dia ? null : dia)}>
                  {dia}
                  {tieneServicio && <div style={{ width: 4, height: 4, borderRadius: '50%', background: '#16a34a', margin: '2px auto 0' }} />}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Detalle día seleccionado */}
      {diaSeleccionado && (() => {
        const serviciosDia = misServicios.filter(s => {
          const f = new Date(s.fecha + 'T12:00:00');
          return f.getFullYear() === año && f.getMonth() === mes && f.getDate() === diaSeleccionado;
        });
        return (
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 }}>
              {diaSeleccionado} de {MESES[mes]}
            </div>
            {serviciosDia.map(s => {
              const tipo = s.tipo || 'servicio';
              const colores = TIPO_COLORS[tipo] || TIPO_COLORS.servicio;
              return (
                <div key={s.id} style={{ background: '#fff', borderRadius: 12, padding: 14, marginBottom: 8, border: '1px solid #e5e5e5' }}>
                  <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    <div style={{ background: colores.bg, borderRadius: 8, padding: '8px 10px', fontSize: 18 }}>
                      {colores.label}
                    </div>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 14 }}>{s.servicio_codigo || s.turno_nombre}</div>
                      <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                        {s.hora_inicio?.substring(0,5)} — {s.hora_fin?.substring(0,5)}
                      </div>
                      {s.base && <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{s.base}</div>}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        );
      })()}

      {/* Tab Servicios */}
      {tab === 'servicios' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {misServicios.length === 0 ? (
            <div style={{ background: '#fff', borderRadius: 14, padding: 40, textAlign: 'center', color: '#aaa' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
              <div>Sin servicios asignados próximamente</div>
            </div>
          ) : misServicios.map(s => {
            const tipo = s.tipo || 'servicio';
            const colores = TIPO_COLORS[tipo] || TIPO_COLORS.servicio;
            const fecha = new Date(s.fecha + 'T12:00:00');
            return (
              <div key={s.id} style={{ background: '#fff', borderRadius: 12, padding: 14, border: '1px solid #e5e5e5' }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <div style={{ background: colores.bg, borderRadius: 8, padding: '8px 10px', fontSize: 18 }}>
                    {colores.label}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, fontSize: 14 }}>
                      {s.servicio_codigo || s.turno_nombre}
                    </div>
                    <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                      {fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}
                    </div>
                    <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                      {s.hora_inicio?.substring(0,5)} — {s.hora_fin?.substring(0,5)} · {s.base}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Modal nuevo servicio */}
      {modalNuevo && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', zIndex: 100 }}>
          <div style={{ background: '#fff', borderRadius: '20px 20px 0 0', padding: 24, width: '100%' }}>
            <h3 style={{ fontSize: 17, fontWeight: 600, margin: '0 0 16px' }}>Nuevo servicio</h3>
            <select value={locoId} onChange={e => setLocoId(e.target.value)}
              style={{ width: '100%', padding: '12px', borderRadius: 10, border: '1px solid #ddd', fontSize: 15, marginBottom: 16 }}>
              <option value="">Seleccionar locomotora...</option>
              {locomotoras.map(l => <option key={l.id} value={l.id}>{l.numero}</option>)}
            </select>
            <button onClick={crearServicio} style={{
              width: '100%', padding: 14, borderRadius: 12, border: 'none',
              background: '#1a1a1a', color: '#fff', fontSize: 15, fontWeight: 500, cursor: 'pointer', marginBottom: 8
            }}>Comenzar servicio</button>
            <button onClick={() => { setModalNuevo(false); setServicioPredefinidoSeleccionado(null); }} style={{
              width: '100%', padding: 14, borderRadius: 12, border: '1px solid #ddd',
              background: '#fff', fontSize: 15, cursor: 'pointer'
            }}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}
